export const GET_ALL_GROUP = 'GET_ALL_GROUP';


